import React from 'react';
import { Header } from '../components/Header';
import { Footer } from '../components/Footer';
import { SEO } from '../components/SEO';
import { ArrowLeftIcon, HandshakeIcon, PhoneCallIcon, TargetIcon } from 'lucide-react';
import { useNavigate } from 'react-router-dom';
export const TeamLidJellePage: React.FC = () => {
  const navigate = useNavigate();
  return <div className="min-h-screen bg-white font-sans text-[#111827]" data-id="element-2178">
      <SEO title="Jelle Zwaanenburg - Sales Executive | Noord Digital" description="Maak kennis met Jelle Zwaanenburg, Sales Executive bij Noord Digital. Eerste aanspreekpunt voor groeivragen en passende voorstellen." canonical="https://noorddigital.nl/over-ons/jelle" data-id="element-2179" />
      <Header data-id="element-2180" />

      <main className="pt-32 pb-20 lg:pt-40 lg:pb-24" data-id="element-2181">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-2182">
          <button onClick={() => navigate('/over-ons')} className="inline-flex items-center gap-2 text-[#004AC7] font-medium hover:underline mb-12" data-id="element-2183">
            <ArrowLeftIcon className="w-4 h-4" data-id="element-2184" /> Terug naar het team
          </button>

          <div className="flex flex-col lg:flex-row gap-16 items-start" data-id="element-2185">
            <div className="lg:w-1/3 flex justify-center lg:justify-start" data-id="element-2186">
              <div className="w-[300px] h-[300px] rounded-full border-4 border-[#004AC7] overflow-hidden shadow-lg" data-id="element-2187">
                <img src="https://cdn.magicpatterns.com/uploads/5AvkpigfrYsv7QATg1Cgrc/WhatsApp_Image_2026-05-09_at_11.41.56.jpg" alt="Jelle Zwaanenburg" className="w-full h-full object-cover" style={{
                objectPosition: 'center 35%'
              }} data-id="element-2188" />
              </div>
            </div>

            <div className="lg:w-2/3" data-id="element-2189">
              <h1 className="text-4xl md:text-5xl font-bold text-[#111827] mb-2" data-id="element-2190">
                Jelle Zwaanenburg
              </h1>
              <p className="text-xl text-[#607697] font-medium mb-8" data-id="element-2191">
                Sales Executive
              </p>

              <div className="prose prose-lg text-[#4B5563] mb-12" data-id="element-2192">
                <p className="mb-4" data-id="element-2193">
                  Als Sales Executive bij Noord Digital ben ik vaak het eerste
                  gezicht waar je mee praat. Ik draai de sales en zorg dat jouw
                  vraag goed begrepen wordt voordat we een voorstel doen.
                </p>
                <p className="mb-4" data-id="element-2194">
                  Ik geloof niet in pushen of gladde verkooppraatjes. Een goed
                  gesprek begint met luisteren: wat speelt er bij jouw bedrijf,
                  waar wil je naartoe en wat is realistisch op korte termijn?
                  Pas daarna kijken we samen of Noord Digital de juiste partner
                  is.
                </p>
                <p data-id="element-2195">
                  Mijn rol is om de brug te slaan tussen jouw groeivraag en het
                  team dat het werk uitvoert. Helder, eerlijk en met een
                  voorstel waar je écht iets aan hebt.
                </p>
              </div>

              <h2 className="text-2xl font-bold text-[#111827] mb-6" data-id="element-2196">
                Expertise
              </h2>
              <div className="grid grid-cols-1 md:grid-cols-3 gap-6 mb-12" data-id="element-2197">
                <div className="bg-[#F7F8FA] p-6 rounded-xl border border-gray-100" data-id="element-2198">
                  <PhoneCallIcon className="w-8 h-8 text-[#004AC7] mb-4" data-id="element-2199" />
                  <h3 className="font-bold text-[#111827]" data-id="element-2200">Sales</h3>
                </div>
                <div className="bg-[#F7F8FA] p-6 rounded-xl border border-gray-100" data-id="element-2201">
                  <HandshakeIcon className="w-8 h-8 text-[#004AC7] mb-4" data-id="element-2202" />
                  <h3 className="font-bold text-[#111827]" data-id="element-2203">Klantcontact</h3>
                </div>
                <div className="bg-[#F7F8FA] p-6 rounded-xl border border-gray-100" data-id="element-2204">
                  <TargetIcon className="w-8 h-8 text-[#004AC7] mb-4" data-id="element-2205" />
                  <h3 className="font-bold text-[#111827]" data-id="element-2206">
                    Voorstellen op maat
                  </h3>
                </div>
              </div>

              <a href="/#contact" className="inline-block bg-[#004AC7] text-white px-8 py-4 rounded-lg font-bold hover:bg-[#003A9E] transition-colors shadow-md" data-id="element-2207">
                Neem contact op met Jelle
              </a>
            </div>
          </div>
        </div>
      </main>

      <Footer data-id="element-2208" />
    </div>;
};